export function startAvailabilityUpdates({ refresh, connect, isVisible, isBusy, onExpired }) {
  let stopped = false, inFlight = false, pending = false, force = false, foreground = false;
  let lastRefresh = -Infinity, healthy = false, failures = 0, generation = 0;
  let connection, retryTimer, changeTimer, fallbackTimer;

  function armFallback() {
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(() => {
      if (!inFlight && isVisible()) request(true);
      armFallback();
    }, connect ? (healthy ? 120000 : 60000) + Math.random() * 15000 : 15000);
  }
  function queue(delay) {
    if (changeTimer) return;
    changeTimer = setTimeout(() => { changeTimer = null; flush(); }, delay);
  }
  function flush() {
    if (stopped || !pending || !isVisible() || inFlight) return;
    if (isBusy()) { queue(1000); return; }
    const delay = force ? 0 : Math.max(0, 15000 - (Date.now() - lastRefresh));
    if (delay) { queue(delay); return; }
    clearTimeout(changeTimer); changeTimer = null;
    const showLoading = foreground;
    pending = false; force = false; foreground = false;
    inFlight = true; lastRefresh = Date.now();
    armFallback();
    Promise.resolve().then(() => refresh(showLoading)).catch(() => {}).finally(() => {
      inFlight = false;
      flush();
    });
  }
  function request(immediate = false, showLoading = false) {
    if (stopped) return;
    pending = true; force ||= immediate; foreground ||= showLoading;
    flush();
  }
  function disconnect() {
    generation += 1;
    connection?.(); connection = null;
    healthy = false;
  }
  function failed(current) {
    if (stopped || current !== generation) return;
    disconnect();
    request();
    clearTimeout(retryTimer);
    retryTimer = setTimeout(() => { retryTimer = null; open(); },
      Math.min(60000, 5000 * 2 ** Math.min(failures++, 4)) + Math.random() * 1000);
  }
  function open() {
    if (stopped || !connect || connection || !isVisible()) return;
    const current = ++generation;
    try {
      connection = connect({
        onReady: () => {
          if (stopped || current !== generation) return;
          healthy = true; failures = 0;
          request();
        },
        onChange: () => { if (current === generation) request(); },
        onError: () => failed(current),
        onExpired: () => {
          if (stopped || current !== generation) return;
          stop(); onExpired();
        },
      });
    } catch { failed(current); }
  }
  function resume() {
    if (stopped) return;
    if (!isVisible()) {
      disconnect();
      clearTimeout(retryTimer); retryTimer = null;
      clearTimeout(changeTimer); changeTimer = null;
      return;
    }
    if (!connection && !retryTimer) open();
    if (Date.now() - lastRefresh >= 1000 && (!inFlight || Date.now() - lastRefresh >= 15000)) request(true);
  }
  function stop() {
    stopped = true;
    disconnect();
    clearTimeout(retryTimer); clearTimeout(changeTimer); clearTimeout(fallbackTimer);
  }
  request(true, true);
  open();
  return { resume, refreshAtBoundary: () => request(true), stop };
}
